import KeyCode from '@root/core/src/utils/keycode';
import { useCallback, useEffect } from '@root/vendor/react';

export default function useModal(onClose, portalRef, isShowing = true, closeWhenClickOutside = true) {
  const handleKeydown = useCallback((event) => {
    if (event.keyCode === KeyCode.KEYCODES.ESC) {
      onClose();
    }
  }, [onClose]);

  const handleClickOutsideModal = useCallback((e) => {
    if (portalRef.current && !portalRef.current.contains(e.target)) {
      onClose();
    }
  }, [onClose, portalRef]);

  useEffect(() => {
    if (isShowing) {
      document.addEventListener('keydown', handleKeydown, false);

      if (closeWhenClickOutside) {
        document.addEventListener('mousedown', handleClickOutsideModal);
      }
    }

    return () => {
      document.removeEventListener('keydown', handleKeydown, false);

      if (closeWhenClickOutside) {
        document.removeEventListener('mousedown', handleClickOutsideModal);
      }
    };
  }, [closeWhenClickOutside, handleClickOutsideModal, handleKeydown, isShowing]);
}
